// Generated by CoffeeScript 2.7.0
var SettingsPanel;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default SettingsPanel = {
  // gid is required
  print_template: function() {
    var file_uploader, input, upload_file_container_el, uploaded_file_container_el, url;
    url = `/admin${this.gid.toPath()}/print_templates`;
    file_uploader = new Skylark.Libs.FileUploader(url, 'file', {
      method: 'patch',
      responseType: 'html'
    });
    upload_file_container_el = DomMaster.find('#js_upload_file_container');
    uploaded_file_container_el = DomMaster.find('#js_uploaded_file_container');
    if (uploaded_file_container_el.node.children.length) {
      upload_file_container_el.hide();
    }
    uploaded_file_container_el.node.proxy('click', '.js-remove-template-file', function() {
      return Skylark.Libs.Ajax.delete(url).success(function() {
        uploaded_file_container_el.html('');
        return upload_file_container_el.show();
      });
    });
    input = DomMaster.find('#js_print_temlpate_file_input').node;
    input.addEventListener('change', function(event) {
      var file, spinner;
      file = input.files[0];
      if (file) {
        spinner = newSpinner({
          loadingText: '正在上传...',
          parent: upload_file_container_el.node
        });
        return file_uploader.upload(file).success(function(html, req) {
          uploaded_file_container_el.html(req.response);
          return upload_file_container_el.hide();
        }).error(function() {
          return newAlertify('不能识别的模板文件，请重新上传', {
            type: 'error'
          });
        }).complete(function() {
          input.value = '';
          if (spinner) {
            return spinner.close();
          } else {
            return spinner = null;
          }
        });
      }
    }, false);
    return DomMaster.find('.template-code-table').node.proxy('click', '.js-variable-code-btn', function(event) {
      var tooltip_el, value_el, variable_code_el;
      variable_code_el = DomMaster.wrap(event._target).closest('.variable-code');
      tooltip_el = variable_code_el.find('.slp-tooltip');
      value_el = variable_code_el.find('.js-variable-code-value');
      if (Skylark.Libs.Clipboard.copy(value_el, {
        clearSelection: true
      })) {
        tooltip_el.removeClass('off');
        return _.delay(function() {
          return tooltip_el.addClass('off');
        }, 600);
      }
    });
  }
};
